import React, { useState } from "react";
import "./Performance.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Nav, Tab, Tabs } from "react-bootstrap";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Summary from "./summary/Summary";
import OrderHistory from "./orderhistory/OrderHistory";

const Performance = () => {
  const [key, setKey] = useState("History_Of_Orders");

  return (
    <section className="performance-page">
      <div className="header-section">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">Performance Overview</h1>

      <div className="performance-content">
        <div className="performance-card">
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
            {/* Custom Tab Navigation */}
            <Nav variant="pills" className="performance-tabs max-md:!px-1">
              {/* <Nav.Item>
                <Nav.Link eventKey="Summary" className="tab-link">
                  Summary
                </Nav.Link>
              </Nav.Item> */}
              <Nav.Item>
                <Nav.Link eventKey="History_Of_Orders" className="tab-link">
                  Order History
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {/* Tab Content */}
            <Tab.Content className="tab-content-area max-md:!p-2">
              {/* <Tab.Pane eventKey="Summary" className="tab-pane">
                <div className="pane-wrapper max-md:!p-3">
                  <Summary />
                </div>
              </Tab.Pane> */}

              <Tab.Pane eventKey="History_Of_Orders" className="tab-pane ">
                <div className="pane-wrapper max-md:!p-3">
                  <OrderHistory />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <div className="footer-section">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Performance;